import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import ExpansionPanelComp from '../../common/ExpansionPanelComp';
import DatiAnteprimaStampa from './DatiAnteprimaStampa';

const styles = theme => ({
  root: {
    width: '100%',
  },
});
			
function DatiAnteprimaStampaPanel(props) {
	
  const { classes } = props;
  return (
    <div className={classes.root}> 
      <ExpansionPanelComp titolo={'anteprimaStampa'} componente={DatiAnteprimaStampa} senzaLensIcon={true} /> 
    </div>
  );
}

DatiAnteprimaStampaPanel.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DatiAnteprimaStampaPanel);
